export const DOSSIER_COLORS = {
    green: ['#00843b','#4da976'],
    orange: ['#f07f3c','#f5a677'],
    red: ['#b44e50','#940104'],
    gray : ['#b3b3af','#80807d']
}